module.exports = __webpack_public_path__ + "img/img-abt1.44b73c1c.jpg";